const value = {
    usersProjectRole: 'Участник, проект или роль',
    championsFirst: 'Сначала чемпионы',
    newFirst: 'Сначала новички',
    usersRating: 'Рейтинг участников',
    fullName: 'ФИО',
    projects: 'Проекты',
    role: 'Роль',
    score: 'Баллы',
    level: 'Уровень',
  };

export default value;
